import Guid from '@/app/utils/guid'
import Address from '@/locations/models/address'

export default class Tenant {

  public id: string = Guid.empty()
  public firstName: string = ''
  public lastName: string = ''
  public company: string = ''
  public vat: string = ''
  public email: string = ''
  public isSmallBusiness: boolean = false
  public address = new Address()
}
